import { IconButton, Tooltip } from '@mui/material';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';

const ButtonHome = () => {
    return (
        <Tooltip title="Go home">
            <IconButton
                href='/'
                style={{
                    backgroundColor: '#feb100',
                    position: 'absolute',
                    top: '15px',
                    left: '10px',
                }}>
                <HomeOutlinedIcon fontSize='small' />
            </IconButton>
        </Tooltip>
    )
}

export default ButtonHome;